import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex gap-3 items-center mb-3" }
const _hoisted_3 = { class: "font-black text-xl" }
const _hoisted_4 = { class: "font-normal text-base" }
const _hoisted_5 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "pb-20"
}
const _hoisted_8 = { class: "flex gap-3 items-center mb-10" }
const _hoisted_9 = { class: "font-black text-xl" }
const _hoisted_10 = { class: "font-normal text-base" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-xl font-bold mb-3" }
const _hoisted_13 = { class: "flex flex-wrap gap-3 my-5" }
const _hoisted_14 = ["innerHTML"]

import { groupBy, filter, last } from "lodash"
  import { onMounted, ref, computed, onBeforeUnmount, onBeforeMount } from "vue"
  import { IonContent, IonPage, modalController } from "@ionic/vue"
  import { useRoute, useRouter } from "vue-router"
  import { useNewsFeedStore } from "@/store/newsfeed"
  import { record } from "@/utils/analytics"
  import AvatarContainer from "@/components/template/avatarTemplate.vue"

  import AvatarTemplate from "@/components/template/avatarTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalContainer',
  setup(__props) {

  const newsfeedStore = useNewsFeedStore()
  const route = useRoute()
  const router = useRouter()
  const currentPost = computed(() => last(newsfeedStore.newsfeedList))
  const ambassadorshipAnswers = computed(() => {
    if (currentPost.value && currentPost.value.answer_content?.answer?.answers?.length > 0) {
      return groupBy(currentPost.value.answer_content?.answer?.answers, "topic")
    }
    return undefined
  })
  /**
   * redirect to workbean world
   * close modal
   */
  const close = () => {
    modalController.dismiss()
    newsfeedStore.newsfeedList.pop()
    router.back()
  }

  /**
   *
   * @param value - answers (array)
   *
   * returns :true if has answers else :false
   */
  const hasAnswers = (value: any) => {
    const gotAnswers = filter(value, (item: any) => item.answer.length && !item.hide)
    return gotAnswers.length ? true : false
  }

  onBeforeMount(async () => {
    await newsfeedStore.retrieveFeed({ feed: router.currentRoute.value.params.id })

    if (newsfeedStore.newsfeedList && newsfeedStore.newsfeedList.length > 0) {
      record({
        event: "FeedViewPage",
        attributes: {
          link: route.fullPath,
          newsfeed_id: currentPost.value?.newsfeed_id,
          company_slug: currentPost.value?.company?.slug || "None",
          content_type: route.params.type || "None",
        },
      })
    }
  })

  onBeforeUnmount(() => {
    localStorage.removeItem("backLink")
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", { class: "flex border-b-1 border-light-gray-300 flex-row-reverse py-2 mb-5" }, [
            _createElementVNode("i", {
              class: "workbean-cross text-xl",
              onClick: close
            })
          ]),
          (_unref(ambassadorshipAnswers))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(AvatarContainer, {
                    image: _unref(currentPost)?.answer_content?.user?.photo,
                    name: _unref(currentPost)?.answer_content?.user?.name?.full_name
                  }, null, 8, ["image", "name"]),
                  _createElementVNode("span", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_unref(currentPost)?.answer_content?.user?.name.full_name) + " ", 1),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(currentPost)?.answer_content?.user?.employment?.role), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ambassadorshipAnswers), (answer, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `${index}_answer`,
                    class: "flex flex-col gap-5 text-left mt-20"
                  }, [
                    (hasAnswers(answer))
                      ? (_openBlock(), _createElementBlock("h2", {
                          key: 0,
                          class: "px-5 py-2 text-white rounded-base font-bold w-fit",
                          style: _normalizeStyle({
              background: _unref(currentPost)?.company?.brand_color ? _unref(currentPost)?.company?.brand_color : '#7442C8',
            })
                        }, _toDisplayString(index), 5))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answer, (answerGroup, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${index}_answerGroup`,
                        class: "pb-20"
                      }, [
                        (answerGroup.answer.length)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(index + 1) + ". " + _toDisplayString(answerGroup?.question), 1))
                          : _createCommentVNode("", true),
                        (answerGroup.answer.length)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 1,
                              class: "mt-2 leading-6",
                              innerHTML: answerGroup?.answer
                            }, null, 8, _hoisted_6))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_unref(currentPost) && _unref(currentPost).answer_content && _unref(currentPost).answer_content.answer && _unref(currentPost).answer_content.answer.answer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(AvatarContainer, {
                    image: _unref(currentPost)?.answer_content?.user?.photo,
                    name: _unref(currentPost)?.answer_content?.user?.name?.full_name
                  }, null, 8, ["image", "name"]),
                  _createElementVNode("span", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_unref(currentPost)?.answer_content?.user?.name.full_name || "Ambassador") + " ", 1),
                    _createElementVNode("p", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_unref(currentPost)?.answer_content?.user?.employment?.role || "Employee") + " ", 1),
                      (_unref(currentPost)?.company?.name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "of " + _toDisplayString(_unref(currentPost)?.company.name), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("h2", _hoisted_12, _toDisplayString(_unref(currentPost).answer_content.answer.topic), 1),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentPost).answer_content.answer.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: `${tag}_topic`,
                      class: "text-white px-4 py-2 rounded-base font-bold",
                      style: _normalizeStyle({ background: `${_unref(currentPost).answer_content.company.brand_color}` })
                    }, _toDisplayString(tag), 5))
                  }), 128))
                ]),
                _createElementVNode("p", {
                  innerHTML: _unref(currentPost).answer_content.answer.answer
                }, null, 8, _hoisted_14)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})